export enum FilesActions {
  Reset = "reset",
  AddFile = "addFile",
  FetchFiles = "fetchFiles",
  DisplayFile = "displayFile",
  DeleteFile = "deleteFile",
  DownloadFile = "downloadFile",
}
